<ion-content *ngIf="renderIFrame" class="iframe-container">
  <iframe #iframe [src]="scrReg" class="iframeFullScreen" frameborder="0"></iframe>
</ion-content>
